/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehouseCaseResponseDTOFromJSON, WarehouseCaseResponseDTOToJSON, } from './WarehouseCaseResponseDTO';
/**
 * Check if a given object implements the PaginatedResponseWarehouseCaseResponseDTO interface.
 */
export function instanceOfPaginatedResponseWarehouseCaseResponseDTO(value) {
    return true;
}
export function PaginatedResponseWarehouseCaseResponseDTOFromJSON(json) {
    return PaginatedResponseWarehouseCaseResponseDTOFromJSONTyped(json, false);
}
export function PaginatedResponseWarehouseCaseResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(WarehouseCaseResponseDTOFromJSON)),
    };
}
export function PaginatedResponseWarehouseCaseResponseDTOToJSON(json) {
    return PaginatedResponseWarehouseCaseResponseDTOToJSONTyped(json, false);
}
export function PaginatedResponseWarehouseCaseResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(WarehouseCaseResponseDTOToJSON)),
    };
}
